<template>
  <div>
    <div class="content-item">
      <div class="content-box">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              placeholder="运单缟号"
              v-model="where.code"
              clearable>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              placeholder="物流编号"
              v-model="where.hao"
              clearable>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              placeholder="收件人电话"
              v-model="where.tel"
              clearable>
            </el-input>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" icon="el-icon-search" :loading="listLoading" @click="getLike">搜索</el-button>
          </el-col>
          <el-col :span="4" :offset="2">
            <el-input
              placeholder="物流编号，如：1-100"
              v-model="exc"
              clearable>
            </el-input>
          </el-col>
          <el-col :span="3">
            <el-button type="danger" icon="el-icon-s-data" :loading="listLoading" @click="getExc">导出</el-button>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 表格 -->
    <div class="content-item">
      <div class="content-box">
        <el-table
          v-loading="listLoading"
          :data="list"
          element-loading-text="Loading"
          fit
          highlight-current-row
        >
          <el-table-column label="运单号">
            <template slot-scope="scope">
              {{ scope.row.code }}
            </template>
          </el-table-column>
          <el-table-column label="物流编号">
            <template slot-scope="scope">
              {{ scope.row.hao }}
            </template>
          </el-table-column>
          <el-table-column label="线路">
            <template slot-scope="scope">
              <el-tag>{{ scope.row.price ? scope.row.price.type.name : '' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="使用积分">
            <template slot-scope="scope">
              <el-link type="danger">{{ scope.row.money }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="保险手续费">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.baoxian }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="燃油费率">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.rate_money }} ({{ scope.row.rate }}%)</el-link>
            </template>
          </el-table-column>
          <el-table-column label="待收款">
            <template slot-scope="scope">
              {{ scope.row.data.reembolso }}
            </template>
          </el-table-column>
          <el-table-column label="下单时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.created_at | dateformat }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="onPDF(scope.row.pdf)"
              >下载PDF</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="content-page">
          <div class="page-container">
            <el-pagination
              :total="total"
              :page-size="pageSize"
              :current-page="currentPage"
              background
              layout="total, prev, pager, next, jumper"
              @current-change="pageLoad"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { user_order } from '../api/api';

export default {
  name: 'Order',
  metaInfo(){
    return {
      title: '我的订单',
    }
  },
  data() {
    return {
      listLoading: false,
      list: [],
      total: 0,
      pageSize: 0,
      currentPage: 0,

      where: {},
      exc: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 列表
    getData() {
      this.listLoading = true
      user_order(this.currentPage, this.where).then(data => {
        this.total = data.total
        this.pageSize = data.per_page
        this.list = data.data
        this.listLoading = false
      })
    },
    // 分页
    pageLoad(page) {
      this.currentPage = page
      this.getData()
    },
    // 搜索
    getLike() {
      this.currentPage = 0
      this.getData()
    },
    onPDF(pdf) {
      window.open(pdf)
    },
    getExc() {
      window.open('/user/cex_order_exc?exc=' + this.exc)
    }
  },
}
</script>